import axios from "axios";
import moment from 'moment';

const jwt = require('jwt-simple');
const clave = 'fanosa-app2021-0x';
//const ENDPOINT_PATH = "http://localhost:3000/api/";
const ENDPOINT_PATH = "https://appbono.fanosa.com/api/";
let userToken = "";
let ath ="";

export default {
  login(email, password, gettoken = null) {
    if (gettoken != null) {
      gettoken = "true";
    }
    const user = {
      email,
      password,
      gettoken,
    };

    let headers = { "Content-Type": "application/x-www-form-urlencoded" };
    return axios.post(ENDPOINT_PATH + "login", user, headers);
  },

  // guardar token en LS
  setToken(token) {
    localStorage.setItem("token", token);
  },

   //Obtener el token guardado en el LS
  getToken() {
    let token = localStorage.getItem("token");

    if (token && token != "undefined") {
      userToken = token;
    } else {
      userToken = null;
    }

    return userToken;
  },

  getMinToken() {
    let token = localStorage.getItem("min");

    if (token && token != "undefined") {
      userToken = token;
    } else {
      userToken = null;
    }

    return userToken;
  },

  // decodificar token
  decode(token){
    let decoded;
    let user = {};
    if(token != null){
     decoded = jwt.decode(token, clave);
     user  = decoded;
    }

    return user;
  },

  encode(token){
    let user = this.decode(token);
    const key = '123asDffsw#2dfggijjflpdcssD28756s1AdvDDgg$52%1289ddgjjDffea2AASa2$#3'
    let payload ={
      sub: user.sub,
      depto: user.depto,
      city: user.city,
      exp:user.exp,
      iat: user.iat,
      name: user.name,
      num:user.num
    }
    return jwt.encode(payload,key);
  },

  logout() {
        localStorage.removeItem('token');

        //this.identity = null;
        //this.token = null;

        //Redireccion a inicio
        this.$router.push("/login");
  },

  createAuth(){
     var payload ={
         auth: 'valido',
         iat:  moment().format(), 
         exp: moment().add(30, 'days').format()  
     };
     let token = jwt.encode(payload, clave);
     return  token;
  },

  setAth(ath) {
    localStorage.setItem("ath", ath);
  }, 

  getAth() {
    let token = localStorage.getItem("ath");

    if (token && token != "undefined") {
      ath = token;
    } else {
      ath = null;
    }

    return ath;
  },

  cityUser(token){
    let identity = this.decode(token)
    let cityUser='';
    if(identity.city=='cancun'){
        cityUser = 'Cancún'
    }else if(identity.city=='cdmexico'){
        cityUser = 'Cd. México'
    }else if(identity.city=='culiacan'){
        cityUser  ='Culiacán'
    }else if(identity.city=='guadalajara'){
        cityUser ='Guadalajara'
    }else if(identity.city=='hermosillo'){
        cityUser = 'Hermosillo'
    }else if(identity.city=='juarez'){
        cityUser  ='Juárez'
    }else if(identity.city=='lapaz'){
        cityUser = 'La Paz'
    }else if(identity.city=='merida'){
        cityUser = 'Mérida'
    }else if(identity.city=='mexicali'){
      cityUser = 'Mexicali'
    }else if(identity.city=='monterrey'){
        cityUser  ='Monterrey'
    }else if(identity.city=='nogales'){
        cityUser ='Nogales'
    }else if(identity.city=='queretaro'){
        cityUser = 'Querétaro'
    }else if(identity.city=='tijuana'){
        cityUser  ='Tijuana'
    }else if(identity.city=='rosarito'){
      cityUser  ='Rosarito'
    }else if(identity.city=='veracruz'){
        cityUser = 'Veracruz'
    }else if(identity.city=='villahermosa'){
        cityUser = 'Villahermosa'
    }

    return cityUser
  }


};

